<template>
  <div class="body">
    <el-row type="flex" align-items="center" style="padding:36px 0 44px 0">
      <el-col >
        <img src="../../assets/Zymebalanz.svg" alt="" class="">
      </el-col>
      <el-col :span="7">
        <el-button
          type="info"
          size="small"
          style="
            background-color:#FFFFFF;
            color: #3E6161;"
          @click="jump()"    
        >
          Sign In
        </el-button>
      </el-col>
    </el-row>

    <el-row>
      <span class="roboto" style="color: #3E6161">
        A BETTER WAY TO PRACTICE.
      </span>
    </el-row>
    <el-row style="padding-top:12px">
      <p>
        Our system was built for functional medicine clinics. With automations and integrations that will make scheduling, charting, and onboarding easier than ever before.
      </p>
    </el-row>
    <el-row style="padding:18px 0 30px 0">
      <el-button
        type="info"
        style="background-color:#3E6161;color: #FFFFFF;font-size:12px"
        @click="scrollMobile()">
        Book a Demo Now
        <i class="el-icon-right el-icon--right" style="font-size:12px"></i>
      </el-button>
    </el-row>
    <div>
      <img src="../../assets/mobile/landing-back.svg" alt="" class="">
    </div>
    <div align="center">
      <el-row style="
        font-family: 'Roboto';
        font-weight: 600;
        font-size: 20px;
        line-height: 23px;
        color: #3E6161;
        ">
        ZHR for the MEDICINE of TODAY
      </el-row>
      <el-row style="
        padding:8px 0 30px 0;
        font-family: 'Roboto';
        font-weight: 400;
        font-size: 13px;
        line-height: 15px;
        color:#9FB556">
        Healthcare is changing. Are you ready to change with it? With our ZHR, you can provide better patient outcomes and experiences.  Smoothly and seamlessly run your clinic with a fully customizable EHR.
      </el-row>
    </div>

  </div>
</template>

<script>
export default {
  props: {
    scrollMobile: {
      type: Function
    }
  },
  methods: {
    jump(){
      console.log('jumping to ZHR site: ')
      window.location.assign("https://zymebalanz.com/ZHR#/")
    }
  }
}
</script>

<style scoped>
.body{
  position: relative;
  width:375px;
  padding:0 28px 0 28px;
}
.roboto{
  font-family: 'Roboto Serif';
  font-weight: 600;
  font-size: 24px;
  line-height: 28px;
  text-transform: capitalize;
}
p{
  width: 320px;
  font-family: 'Roboto';
  font-weight: 400;
  font-size: 14px;
  line-height: 16px;
  color:#3E6161;
}
  </style>